import operationTypes from 'constants/operationTypes';

type GetTransactionTypeLabelKeyProps = {
  operationType: string;
  transactionType: string;
};

const transactionLabelMap: Record<string, Record<string, string>> = {
  [operationTypes.SELL_PARTICIPATION]: {
    BUY: 'Buy',
    SELL: 'Sell',
  },
  [operationTypes.ENDORSEMENT]: {
    BUY: 'BuyEndorsement',
    SELL: 'SellEndorsement',
  },
  [operationTypes.HERITAGE]: {
    BUY: 'BuyHeritage',
    SELL: 'SellHeritage',
  },
  [operationTypes.DONATION]: {
    BUY: 'BuyDonation',
    SELL: 'SellDonation',
  },
  [operationTypes.TRANSMISSION]: {
    BUY: 'BuyTransmission',
    SELL: 'SellTransmission',
  },
};

export const getTransactionTypeLabelKey = ({
  operationType,
  transactionType,
}: GetTransactionTypeLabelKeyProps): string =>
  transactionLabelMap[operationType]?.[transactionType] ?? operationType;
